"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessTaxonomyBodyToJSON = exports.BusinessTaxonomyBodyFromJSONTyped = exports.BusinessTaxonomyBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function BusinessTaxonomyBodyFromJSON(json) {
    return BusinessTaxonomyBodyFromJSONTyped(json, false);
}
exports.BusinessTaxonomyBodyFromJSON = BusinessTaxonomyBodyFromJSON;
function BusinessTaxonomyBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'image': !(0, runtime_1.exists)(json, 'image') ? undefined : json['image'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'priority': !(0, runtime_1.exists)(json, 'priority') ? undefined : json['priority'],
    };
}
exports.BusinessTaxonomyBodyFromJSONTyped = BusinessTaxonomyBodyFromJSONTyped;
function BusinessTaxonomyBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'image': value.image,
        'description': value.description,
        'priority': value.priority,
    };
}
exports.BusinessTaxonomyBodyToJSON = BusinessTaxonomyBodyToJSON;
